import { useState } from 'react'
import Formsy from 'formsy-react'
import classnames from 'classnames'
import { initiateSignupFlow } from 'login-and-signup/actions'
import { languageSelector } from 'i18n/selectors'

import featureToggles from 'shared/featureToggles'
import { CUSTOMER_TYPE_BUSINESS, CUSTOMER_TYPE_INDIVIDUAL } from 'shared/constants'

import DefaultFlowForm from './DefaultFlowForm'
import SubscriptionLiteForm from './SubscriptionLiteForm'

import styles from '../styles.module.scss'

const SignupContainer = ({ initiateSignupFlow, active, handleFocus, language, signUpFormError }) => {
    const [canSubmit, setCanSubmit] = useState(false)
    const [acceptTerms, setAcceptTerms] = useState(false)

    // If additional signup fields are used
    const [customerType, setCustomerType] = useState(CUSTOMER_TYPE_INDIVIDUAL)

    const acceptTermsHandler = event => {
        setAcceptTerms(event.target.checked)
    }

    const enableSubmit = () => {
        setCanSubmit(true)
    }

    const disableSubmit = () => {
        setCanSubmit(false)
    }

    const submit = data => {
        const { firstName, lastName, email, password, news, offers, nif, documentNumber, businessName, phone } = data
        initiateSignupFlow(
            firstName,
            lastName,
            email,
            password,
            !!news,
            !!offers,
            nif,
            featureToggles.additionalSignupData ? customerType : '',
            documentNumber,
            businessName,
            phone
        )
    }

    return (
        <div tabIndex="0" className={`header-signup-container ${active ? 'active' : ''}`} onFocus={handleFocus}>
            <Formsy
                className="header-form signup-form"
                onSubmit={submit}
                onValid={enableSubmit}
                onInvalid={disableSubmit}>
                <fieldset>
                    {/* hidden "fake" input fields to disable autofill */}
                    <input type="email" name="email" className="d-none" />
                    <input type="password" name="pasword" className="d-none" />
                    {featureToggles.additionalSignupData && (
                        <input type="text" name="customerType" value={customerType} className="d-none" />
                    )}
                    <legend>
                        <h2>
                            <T>auth.sign.up.title</T>
                        </h2>
                    </legend>
                    {(featureToggles.additionalSignupData || featureToggles.hasSubcriptionLite) && (
                        <div className="d-flex">
                            <span
                                onClick={() => setCustomerType(CUSTOMER_TYPE_INDIVIDUAL)}
                                className={classnames(styles.userType, {
                                    [styles.selected]: customerType === CUSTOMER_TYPE_INDIVIDUAL,
                                })}>
                                <T>auth.sign.up.type.individual</T>
                            </span>
                            <span
                                onClick={() => setCustomerType(CUSTOMER_TYPE_BUSINESS)}
                                className={classnames(styles.userType, {
                                    [styles.selected]: customerType === CUSTOMER_TYPE_BUSINESS,
                                })}>
                                <T>auth.sign.up.type.business</T>
                            </span>
                        </div>
                    )}
                    {(!featureToggles.hasSubcriptionLite || customerType === CUSTOMER_TYPE_INDIVIDUAL) && (
                        <DefaultFlowForm
                            active={active}
                            canSubmit={canSubmit}
                            acceptTerms={acceptTerms}
                            acceptTermsHandler={acceptTermsHandler}
                            customerType={customerType}
                            signUpFormError={signUpFormError}
                        />
                    )}
                    {featureToggles.hasSubcriptionLite && customerType === CUSTOMER_TYPE_BUSINESS && (
                        <SubscriptionLiteForm language={language} />
                    )}
                </fieldset>
            </Formsy>
        </div>
    )
}

export default compose(
    connect(createStructuredSelector({ language: languageSelector }), {
        initiateSignupFlow,
    })
)(SignupContainer)
